const defaultSuffix = '([!%]?[\\w]*)'; // like !default / !edit / %21viewLogs
export const globalSettingsSystemImportCsvRoute = {
	name: 'global-settings-system-import-csv',
	path: `/(secure|secure/admin)/Csv(\\w+)Page${defaultSuffix}.jspa`,
};
